import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Avatar, BlockStack, Button, Collapsible, Divider, Icon, InlineStack, ResourceItem, ResourceList, Scrollable, Spinner, Text } from '@shopify/polaris';
import { PhoneInIcon, PhoneOutIcon, PhoneIcon, PlusIcon, ViewIcon, LinkIcon, MenuHorizontalIcon, PlayCircleIcon } from '@shopify/polaris-icons';
import dateandtime from 'date-and-time';
import CustomerNew from 'entities/customer/customer.new';
import helpers from 'helpers/index';
import { TypedPhoneLog, useMutateGetPhonelogs } from 'queries/phonelog.query';
import AudioPlayer from 'entities/phonelog/components/audio-player';
export default function PhoneCallLog({
  show
}: {
  show: boolean;
}) {
  const {
    mutateAsync: getEntities,
    data
  } = useMutateGetPhonelogs();
  const [entities, setEntities] = useState<TypedPhoneLog[]>([]);
  const current_page = useRef(1);
  const [loading, setLoading] = useState(false);
  const [reachingEndData, setReachingEndData] = useState(false);

  // useEffect(() => {
  //   if (data) {
  //     setEntities(data.body);
  //     setTotalItems(data.totalItems);
  //   }
  // }, [data]);

  /**
   * Ngưỡng hiển thị ...
   */
  // const threshold_display_for_infinite_loading = useRef(20);

  const loadData = useCallback(async () => {
    setLoading(true);
    try {
      let {
        body
      } = await getEntities({
        sort: 'createdAt:desc',
        limit: 20,
        page: current_page.current || 1
      });
      if (Array.isArray(body) && body.length < 1) {
        setReachingEndData(true);
      }
      let newData = [...body, ...entities];
      setEntities(newData);
    } catch (e) {}
    setLoading(false);
  }, []);
  useEffect(() => {
    if (!show) return;
    loadData();
  }, [show]);
  const [showNewCustomer, setShowNewCustomer] = useState(null);
  const currentNumber = useRef(null);
  const [currentPhonelogID, setCurrentPhonelogID] = useState(null);
  const doClick = useCallback((phonglog_id: string, phonelog_number: any, user?: any) => {
    if (user) return;
    setCurrentPhonelogID(phonglog_id);
    setShowNewCustomer(true);
    currentNumber.current = phonelog_number;
  }, [setCurrentPhonelogID]);
  const closeNewCustomerModal = useCallback(async (user_id: any) => {
    setShowNewCustomer(false);
    current_page.current = 1;
    if (currentPhonelogID)
      // await updateEntity({
      //   phonelog_id: currentPhonelogID,
      //   user_id: user_id,
      // });
      await helpers.sleep(1000);
    await loadData();
  }, [currentPhonelogID]);
  const loadMoreAfterReachEnd = useCallback(() => {
    current_page.current = current_page.current + 1;
    loadData();
  }, [current_page]);
  const fetchDataMemo = useMemo(() => {
    if (reachingEndData) return;
    return helpers.debounce(() => {
      loadMoreAfterReachEnd?.call(this);
    }, 500);
  }, [loadMoreAfterReachEnd, reachingEndData]);
  const loadingMarkup = loading ? <InlineStack align="center" blockAlign="center" gap="200">
      <br />
      <Spinner accessibilityLabel="Loading more content" size="small" />
      <br />
    </InlineStack> : null;
  const [collapsibleDiv, setCollapsibleDiv] = useState(null);
  const [idPlaying, setIdPlaying] = useState(false);
  const currentlyPlayingRef = useRef(null); // Lưu tham chiếu tới audio đang phát

  return <div id="phone_call_log">
      {<CustomerNew onClose={closeNewCustomerModal} show={!!showNewCustomer} defaultNumber={currentNumber.current} />}

      <Scrollable onScrolledToBottom={fetchDataMemo} style={{
      height: 'calc(100vh - 35px)'
    }} shadow focusable>
        <ResourceList resourceName={{
        singular: 'customer',
        plural: 'customers'
      }} items={data?.body || []} renderItem={(item, index) => {
        const {
          id,
          destination,
          source,
          source_data,
          destination_data,
          disposition,
          recordingfile,
          duration,
          direction,
          createdAt,
          answeredBy
        } = item;
        // const media = <Avatar customer size="md" name={source_data?.display_name} source={source_data?.user_avatar} />;

        return <ResourceItem verticalAlignment="center" id={id} url={destination_data ? '/users/view/' + destination_data.user_id : '#'}
        // media={media}
        onClick={() => {
          setCollapsibleDiv(id);
        }}>
                <BlockStack gap="200">
                  <InlineStack gap="200" align="space-between" blockAlign="center">
                    <InlineStack gap="200" align="start" blockAlign="center">
                      <span>
                        <Icon source={direction === 'inbound' ? PhoneInIcon : PhoneOutIcon} tone={disposition === 'MISSED' ? 'critical' : 'info'} />
                      </span>
                      <Text as="p" fontWeight="bold" variant="bodyMd" tone={disposition === 'MISSED' ? 'critical' : 'base'}>
                        {source_data && source_data?.display_name || source}
                      </Text>
                    </InlineStack>
                    <Text as="p" tone="subdued" variant="bodySm">
                      {dateandtime.format(new Date(Number(createdAt)), 'HH:mm DD/MM')}
                    </Text>
                  </InlineStack>
                  <Collapsible open={collapsibleDiv === id} id="basic-collapsible" transition={{
              duration: '100ms',
              timingFunction: 'ease-in-out'
            }} expandOnPrint>
                    <BlockStack gap="100">
                      <InlineStack gap="200" align="start" blockAlign="center">
                        <Text as="span" tone="subdued">
                          {helpers.secondToFullHourString(duration)}
                        </Text>
                        <Text as="span" tone="subdued">
                          Đến {destination}
                        </Text>
                        {answeredBy ? <Text as="span" tone="subdued">
                            Trả lời bởi {answeredBy}
                          </Text> : null}
                      </InlineStack>
                      <InlineStack align="space-between" blockAlign="center">
                        {helpers.isLink(recordingfile) && duration > 0 ? <AudioPlayer id={id} duration={duration} idPlaying={idPlaying} setIdPlaying={setIdPlaying} currentlyPlayingRef={currentlyPlayingRef} audioUrl={recordingfile || ''} /> : <Button disabled tone="critical" variant="plain" icon={PlayCircleIcon}>
                            00:00:00
                          </Button>}
                        <div>
                          {!source_data ? <Button icon={PlusIcon} variant="plain" onClick={() => doClick(id, source, source_data)}>
                              Thêm vào danh bạ
                            </Button> : <Button icon={MenuHorizontalIcon} variant="plain" onClick={() => window.location.replace(`customer/view/${source_data?.user_id}`)}>
                              Xem profile
                            </Button>}
                        </div>
                      </InlineStack>
                    </BlockStack>
                  </Collapsible>
                </BlockStack>
              </ResourceItem>;
      }} />
        {reachingEndData && <Text as="p" alignment="center" tone="critical" variant="bodySm" fontWeight="bold">
            Không còn dữ liệu
          </Text>}
        {loadingMarkup}
      </Scrollable>
    </div>;
}